import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
/*
 * @TODO: Request a new Icon
 * @see [WFICON-12] {@link https://jira.ttt-sp.com/browse/WFICON-12}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a ribbon icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <RibbonIcon width={12} />
 */
const RibbonIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M20.3,10.5l-1.48,1.66l0.21,2.2c0.04,0.39-0.22,0.75-0.61,0.84l-2.2,0.49l-1.15,
            1.9c-0.14,0.24-0.41,0.39-0.68,0.39c-0.1,0-0.21-0.02-0.31-0.06L12,
            17.05l-2.06,0.89C9.83,17.98,9.73,18,9.62,
            18c-0.28,0-0.54-0.14-0.69-0.39l-1.15-1.9l-2.2-0.49c-0.38-0.09-0.65-0.45-0.61-0.84l0.21-2.21L3.7,
            10.52c-0.26-0.3-0.26-0.74,0-1.03l1.48-1.67L4.97,5.62C4.93,5.22,5.2,4.87,5.59,
            4.78L7.79,4.3l1.16-1.9c0.14-0.24,0.41-0.39,0.68-0.39c0.1,0,0.21,0.02,0.31,0.06L12,2.95l2.07-0.89C14.17,
            2.02,14.28,2,14.38,
            2c0.27,0,0.54,0.14,0.69,0.39l1.15,1.9l2.2,0.49c0.38,0.09,0.65,0.45,0.61,0.84l-0.21,2.2l1.48,
            1.66C20.57,9.78,20.57,10.22,20.3,10.5z M8.08,18.13L7.15,16.6l-0.46-0.1L5,21l2-1l1,2l1.15-3.06C8.71,
            18.82,8.33,18.54,8.08,18.13zM16.84,16.58l-0.92,1.53c-0.24,0.4-0.63,0.69-1.08,0.81L16,
            22l1-2l2,1l-1.7-4.53L16.84,16.58z M12,4c-3.31,0-6,2.69-6,6s2.69,6,6,
            6s6-2.69,6-6S15.31,4,12,4z M12,5c-2.76,0-5,2.24-5,5s2.24,5,5,5s5-2.24,5-5S14.76,5,12,5z`}
        />
    </SvgIcon>
)

RibbonIcon.defaultProps = defaultProps

export { RibbonIcon }
